import { Pagination } from 'antd';
import { usePayoutInvoicesTableStore } from 'store/payoutInvoicesTable';
import { usePayoutInvoicesTableFiltersStore } from 'store/payoutInvoicesTableFilters';
import type { TComponent } from 'utils/types/component';

export const CustomPagination: TComponent = () => {
    const params = usePayoutInvoicesTableFiltersStore('reportsParams');
    const totalElements = usePayoutInvoicesTableStore('totalReportsElements');

    const setParams = usePayoutInvoicesTableFiltersStore('setReportsParams');
    const getPayoutReports = usePayoutInvoicesTableStore('getPayoutReports');

    const page = params.page + 1;

    const handleChangePage = (currentPage: number, pageSize: number) => {
        const enhancePage = currentPage - 1;

        const newParams = { ...params, page: enhancePage, size: pageSize };

        setParams(newParams);
        getPayoutReports(newParams);
    };

    return (
        <Pagination
            showSizeChanger
            current={page}
            total={totalElements}
            onChange={handleChangePage}
        />
    );
};
